import { bindTokenProvider, createHttpClient, session } from '@/core';

/**
 * HTTP 装配点 — 两档口径（《前端项目开发文档 v1.1》§3.5 + 《后端项目开发文档 v1.5》§6.0）
 *
 * | 档位 | 变量 | 行为 |
 * |---|---|---|
 * | 直连 | `VITE_API_BASE_URL=http://<backend-host>:<port>/api` | 真实请求；前缀由 base 给 |
 * | 走代理 | `VITE_API_BASE_URL=/api`（同源） | 由 vite server.proxy 原样转发，**不使用 rewrite** |
 *
 * ⚠ **`/api` 前缀只许由 base 提供一次**：全仓 target 字面量一律裸形（`/orders`、`/approvers/query`…）。
 * 历史里曾有唯一一枚自带前缀的例外——`POST /api/approvers/query`（后端 seq761 三①，`ContractGapModule.cs:95`，
 * 当时 base 不带前缀而它带）⇒ 那是**有期限的甲案**，不是先例。后端 #81 装载前缀、`d3f08f4` 起 base 改带
 * `/api`（群主 seq=181 裁定保留）之后，那枚例外打出去就成了 `/api/api/approvers/query`，本机 8080 实测 **404**
 * ⇒ 2026-09-17 按甲案原计划改回。同批动的两处＝`api/role.ts` 的 target 与 `apiPaths.assert.ts` 里的臂
 * （少一处就是「本地对账通、联调 404」）。⛔ 再往任何 target 里补前缀。
 *
 * §6.2 七项缺口端点：接桩机制已按裁定**整体下线**（模块本体与判别断言同批删除）。
 * 本装配点一律走真实后端——404/405 与非统一信封应答**直接向上抛错**，⛔ 不回任何桩数据。
 */

/** 401：清会话 + 跳登录（带 redirect 回跳），由路由守卫兜底 */
bindTokenProvider({
  getAccessToken: () => session.getAccessToken(),
  onUnauthorized: () => {
    session.clearSession();
    const redirect = encodeURIComponent(window.location.hash.replace(/^#/, '') || '/dashboard');
    window.location.hash = `#/login?redirect=${redirect}&reason=session`;
  },
});

export const http = createHttpClient({});

export { getContractDrift } from '@/core';

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '(同源 → dev proxy)';
